import {Workspace, WorkspaceBookType, WorkspaceToCreate} from '@innowise-group/core';

export interface WorkspaceMovePayload {
  id: number;
  coordinates: Array<number[]>;
  rotate_degree: number;
  status: WorkspaceBookType;
}

export const updateWorkspaceMoveData = (workspace: {
  id: string | number;
  coordinates: Array<number[]>;
  rotateDegree: number;
  status: WorkspaceBookType;
}): WorkspaceMovePayload => ({
  id: Number(workspace.id),
  coordinates: workspace.coordinates,
  rotate_degree: workspace.rotateDegree,
  status: workspace.status,
});

export const toWorkspaceCreatePayload = (workspace: Workspace, floorId: string | number): WorkspaceToCreate => {
  const {status, employee, comment, range, rotateDegree, coordinates} = workspace;

  return {
    status,
    employee: employee?.id ? Number(employee.id) : null,
    occupation_start_date: range?.startDay ? new Date(range.startDay).toISOString() : null,
    occupation_end_date: range?.endDay ? new Date(range.endDay).toISOString() : null,
    coordinates,
    comment: comment ? comment : null,
    rotate_degree: rotateDegree,
    floor: Number(floorId),
  };
};
